import { ServiceRequestType } from './serviceRequest.types';
import { UserType } from './user.types';
import { CommercialVisitType } from './commercialVisit.types';

export type CostType = {
  _id: string;
  serviceRequest?: string | ServiceRequestType;
  commercialVisit?: string | CommercialVisitType;
  costType: 'technical_direct' | 'commercial_direct' | 'indirect';
  category: 
    // Custos Diretos do Chamado Técnico
    | 'parts_materials'       // Peças e Materiais
    | 'technical_labor'       // Mão de Obra Técnica
    | 'transportation'        // Deslocamento/Logística
    | 'special_equipment'     // Equipamentos Especiais
    | 'licenses_certifications' // Licenças ou Certificações
    
    // Custos Diretos do Atendimento Comercial
    | 'commercial_labor'      // Mão de Obra Comercial
    | 'visit_transportation'  // Deslocamento para Visita
    | 'demo_materials'        // Materiais de Demonstração
    | 'accommodation_food'    // Hospedagem/Alimentação
    | 'presentation_tools'    // Ferramentas de Apresentação
    
    // Custos Indiretos
    | 'administrative_management' // Gestão Administrativa
    | 'systems_licenses'      // Sistemas e Licenças
    | 'physical_infrastructure' // Infraestrutura Física
    | 'training'              // Treinamento e Capacitação
    | 'other';                // Outros custos
  description: string;
  amount: number;
  date: string;
  registeredBy: string | UserType;
  
  // Campos para cálculos específicos
  hourlyRate?: number;
  hoursWorked?: number;
  kilometers?: number;
  costPerKilometer?: number;
  quantity?: number;
  unitCost?: number;
  technician?: string; // ID do técnico responsável
  
  notes?: string;
  attachments?: Array<{
    url: string;
    filename: string;
    contentType: string;
    uploadDate: string;
  }>;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type CostFormValues = Omit<CostType, '_id' | 'registeredBy' | 'isActive' | 'createdAt' | 'updatedAt'>;

export type CostSummaryType = {
  costType: string;
  categories: Array<{
    category: string;
    count: number;
    totalAmount: number;
    avgAmount: number;
    minAmount: number;
    maxAmount: number;
  }>;
  totalCount: number;
  totalAmount: number;
};

export type CostCategoryLabels = {
  [key: string]: string;
};

export const COST_CATEGORY_LABELS: CostCategoryLabels = {
  // Custos Diretos do Chamado Técnico
  parts_materials: 'Peças e Materiais',
  technical_labor: 'Mão de Obra Técnica',
  transportation: 'Deslocamento/Logística',
  special_equipment: 'Equipamentos Especiais',
  licenses_certifications: 'Licenças ou Certificações',
  
  // Custos Diretos do Atendimento Comercial
  commercial_labor: 'Mão de Obra Comercial',
  visit_transportation: 'Deslocamento para Visita',
  demo_materials: 'Materiais de Demonstração',
  accommodation_food: 'Hospedagem/Alimentação',
  presentation_tools: 'Ferramentas de Apresentação',
  
  // Custos Indiretos
  administrative_management: 'Gestão Administrativa',
  systems_licenses: 'Sistemas e Licenças',
  physical_infrastructure: 'Infraestrutura Física',
  training: 'Treinamento e Capacitação',
  other: 'Outros'
};

export const COST_TYPE_LABELS = {
  technical_direct: 'Custo Direto Técnico',
  commercial_direct: 'Custo Direto Comercial',
  indirect: 'Custo Indireto'
};
